// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2a7155ae","455":"a11a788f","977":"8e2c4f8d"}[chunkId] + ".chunk.js";
};